import React, { useState, useEffect } from "react";
import { Col, FormGroup, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Input } from "reactstrap";
import CollectionSubMenu from "./collectionSubMenu";
import TableData from "./TableData";

export default function CollectedNft() {
  const location = useLocation();
  const { page } = location.state;
  const navigate = useNavigate();
    const { authToken, user, settings } = useSelector((state) => state?.Login);
    const Redirect = () => {
        const GetAddress = localStorage.getItem("walletAddress");
        if (GetAddress) {
          navigate("../nft/createnft");
        } else {
          navigate("/metamask-sign");
        }
      };
  return (
    <>
      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <h1>Collected</h1>
            {authToken &&
                    user?.role !== "USER" &&
                    user?.verificationProfileStatus === "accept" && (
                <button onClick={Redirect} className="btn btn-primary px-5"> <i className="fa-light fa-plus"></i> List on Marketplace</button>
                )}
          </div>
        </Col>
      </Row>
      <TableData data={page} />
    </>
  );
}
